import { IPromise } from 'angular';
import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { callViaApiService, GroupDatabasesRequestBody, GroupDatabasesResponse } from '../../../../ts/restApi/GroupDatabases';
import { ConfirmActionDialog } from '../../../../ts/services/ConfirmActionDialog';
import { RestApiErrorData, RestApiErrorResponse } from '../../../../ts/services/RestApiService';
import { ToasterService, ToastType } from '../../../../ts/services/ToasterService';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { GroupDatabasesAction } from '../../../actions/spaces/GroupDatabasesAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { ServiceLocator } from '../../../ServiceLocator';
import { reloadSpaceIfUpdatingCurrentSpace } from './RefreshContentSagas';


export function* handleGroupDatabases(action: GroupDatabasesAction) {
  try {
    yield call(openConfirmationDialog, action.items);

    const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, action.items);
    if (!maybeReloaded) {
      yield put(requestSpaceContents());
    }
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

function openConfirmationDialog(items: GroupDatabasesAction['items']): IPromise<unknown> {
  // TODO: Most of the other Catalog actions use ReactModalService dialogs.
  // When we add widgets to the dialog content, let's consider switching over. TFS 1040404
  const angularContext = ServiceLocator.getAngularActionContext();
  const dialogScope = angularContext.scope.$new();
  const confirmActionDialog = ServiceLocator.get<ConfirmActionDialog>('ConfirmActionDialog');

  return confirmActionDialog.open({
    scope: dialogScope,
    title: 'Group Databases',
    bodyText: 'Check the network tools to see the REST API response',
    actionName: 'Call REST API',
    action: () => makeApiCall(items),
  }).result.finally(() => dialogScope.$destroy());
}

export async function makeApiCall(items: GroupDatabasesAction['items']): Promise<GroupDatabasesResponse> {
  const body: GroupDatabasesRequestBody = {
    databaseGroup: {
      metadataDatabaseId: items[0].luid,
      database: items.map(item => ({ id: item.luid })),
    },
  };

  const toaster = ServiceLocator.get<ToasterService>('ToasterService');

  try {
    const result = await callViaApiService(body);
    toaster.pop({
      type: ToastType.Success,
      text: `Merged database is named ${result.database.name}`,
    });
    return result;

  } catch (e) {
    const errorResponse = e as RestApiErrorResponse;
    toaster.pop({
      type: ToastType.Error,
      text: `${errorResponse.status} ${errorResponse.statusText}`,
    });
  }
}
